import HTTP from '@/plugins/http';
import utils from '@/resources/utils';
import validationStatusCode from '@/resources/validation_status_code';

const getAppointments = async (token, page) => validationStatusCode(
  await HTTP.get(`/appointments/?page=${page}`, { headers: utils.headerAuth(token) })
);

const getAppointment = async (id, token) => validationStatusCode(
  await HTTP.get(`/appointments/${id}`, { headers: utils.headerAuth(token) })
);

const createAppointment = async (appointment, token) => validationStatusCode(
  await HTTP.post('/appointments/', appointment, { headers: utils.headerAuth(token) })
);

const updateAppointment = async (id, appointment, token) => {
  return  validationStatusCode(
    await HTTP.patch(
      `/appointments/${id}/`,
      appointment,
      { headers: utils.headerAuth(token) }
    )
  );
}

const deleteAppointment = async (id, token) => validationStatusCode(
  await HTTP.delete(`/appointments/${id}/`, { headers: utils.headerAuth(token) })
);

export default {
  getAppointment,
  getAppointments,
  createAppointment,
  updateAppointment,
  deleteAppointment,
}
